module.exports = __webpack_public_path__ + "b96704a0cc12921ecbdae96888b16f6c.js";